import React from 'react';

const Scatter = function Scatter({
  cx,
  cy,
  onMouseOver,
  onMouseLeave,
  icon,
  color,
  size = 15,
  onClick,
}) {
  return (
    <g>
      <circle
        cx={cx}
        cy={cy}
        r={size}
        fill={color}
        strokeWidth={2}
        onMouseMove={onMouseOver}
        onMouseLeave={onMouseLeave}
        onClick={onClick}
        style={{ cursor: 'pointer' }}
      />
      {icon && (
        //React's foreignObject to render MUI icon inside SVG
        (<foreignObject
          x={cx - 12}
          y={cy - 12}
          width={24}
          height={24}
          style={{ pointerEvents: 'none' }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              height: '100%',
              color: 'white',
            }}
          >
            {React.createElement(icon, { style: { fontSize: 18 } })}
          </div>
        </foreignObject>)
      )}
    </g>
  );
};

export default Scatter;
